define('plugin/group-booking/view/GroupBookingView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    return LayoutView.extend({

        template: '#group_booking_view',
        _bookingModel: null,
        _serviceModel: null,
        _maxCount: 1,
        _minCount: 1,
        _default: 1,

        ui: {
            count: ':input'
        },

        safeRender: function () {
            if (!this.isDestroyed) {
                this.render();
            }
        },

        initialize: function () {
            this._bookingModel = this.getOption('bookingModel');
            this._serviceModel = this.getOption('serviceModel');
            this._maxCount = this.getOption('count');
            this._minCount = this.getOption('minCount');
            if(this.getOption('default') && this.getOption('default')>0) {
                this._default = this.getOption('default');
            }
            //
            // if(this._default < this._minCount){
            //     this._default = this._minCount;
            // }

            this.listenTo(this._bookingModel, 'change:service_id', this.onServiceChanged);
            this.listenTo(this._bookingModel, 'reset:count', this.render);
        },

        onServiceChanged: function () {
            if (this._bookingModel.get('service_id') === this._serviceModel.get('id')) {
                var count = parseInt(this.ui.count.val());

                if (!_.isNumber(count) || count < this._minCount) {
                    count = this._default;
                }

                this._bookingModel.set('count', count);
                this.triggerMethod('change:count', count);
            }
        },

        serializeData: function () {
            var result = LayoutView.prototype.serializeData.apply(this);
            result.count = this._maxCount;
            result.min_count = this._minCount;
            result.default = this._bookingModel.get('count') || this._default;
            if (result.default < this._minCount) {
                result.default = this._minCount;
            } else if (result.default > this._maxCount) {
                result.default = this._maxCount;
            }
            return result;
        }

    });

});
